/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_EmptyInputs */

const en_branches_empty = /** @type {(inputs: Branches_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No branches yet.`)
};

const pt_br2_branches_empty = /** @type {(inputs: Branches_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma filial ainda.`)
};

/**
* | output |
* | --- |
* | "No branches yet." |
*
* @param {Branches_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_empty = /** @type {((inputs?: Branches_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_empty(inputs)
	return pt_br2_branches_empty(inputs)
});